import { ApolloLink } from "./ApolloLink.js";
export var execute = ApolloLink.execute;
//# sourceMappingURL=execute.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/execute.js
// module id = ./node_modules/@apollo/client/link/core/execute.js
// module chunks = 54 55